import type { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { formatRouteRelativeTime } from '../../helpers/datetime'
import type { WaypointTime } from '../../helpers/waypointTimes'
import type { TimelineDate } from './types'

/** One schedule row; a recorded time reads as past tense, like v1. */
const ScheduleItem = ({
  time,
  plannedLabel,
  recordedLabel,
  datetime,
}: {
  time?: WaypointTime
  plannedLabel: MessageDescriptor
  recordedLabel: MessageDescriptor
  datetime: TimelineDate
}) => {
  const { _ } = useLingui()
  if (!time) return null
  return (
    <div className='route-timeline__sched-item'>
      <span className='route-timeline__sched-label'>
        {_(time.isRecorded ? recordedLabel : plannedLabel)}
      </span>
      <span className='route-timeline__sched-value'>
        {formatRouteRelativeTime(time.at, datetime)}
      </span>
    </div>
  )
}

/** Arrive/Depart schedule rows inside a waypoint card. */
export const WaypointSchedule = ({
  arrival,
  departure,
  datetime,
}: {
  arrival?: WaypointTime
  departure?: WaypointTime
  datetime: TimelineDate
}) => {
  const hasSchedule = arrival != null || departure != null
  if (!hasSchedule) return null
  return (
    <div className='route-timeline__schedule'>
      <ScheduleItem
        time={arrival}
        plannedLabel={msg`Arrive`}
        recordedLabel={msg`Arrived`}
        datetime={datetime}
      />
      <ScheduleItem
        time={departure}
        plannedLabel={msg`Depart`}
        recordedLabel={msg`Departed`}
        datetime={datetime}
      />
    </div>
  )
}
